module.exports = __webpack_public_path__ + "static/media/MountainPeakFlashbackA0017_design_clean_v002.f3a988c8.png";